import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ImportsSheetMeta } from '@customerio/hydra-ui-api';
import { hydraUiApi } from '@/services/api';

export type SpreadsheetSheetOption = {
  label: string;
  value: string;
};

export type ListSpreadsheetSheetsInput = {
  workspaceId: number;
  spreadsheetId: string;
};

export const googleSheetsKeys = {
  sheets: (workspaceId: number, spreadsheetId: string) =>
    ['workspace', workspaceId, 'spreadsheet', spreadsheetId, 'sheets'] as const,
};

function toSheetOption(sheet: ImportsSheetMeta): SpreadsheetSheetOption {
  return { label: sheet.name, value: String(sheet.id) };
}

export async function listSpreadsheetSheets({
  workspaceId,
  spreadsheetId,
}: ListSpreadsheetSheetsInput): Promise<SpreadsheetSheetOption[]> {
  const response = await hydraUiApi.imports.getSpreadsheetsSheets({
    params: { path: { environment_id: String(workspaceId), spreadsheet_id: spreadsheetId } },
  });

  return response.sheets.map(toSheetOption);
}

export function listSpreadsheetSheetsQueryOptions({ workspaceId, spreadsheetId }: ListSpreadsheetSheetsInput) {
  return queryOptions({
    queryKey: googleSheetsKeys.sheets(workspaceId, spreadsheetId),
    queryFn: () => listSpreadsheetSheets({ workspaceId, spreadsheetId }),
  });
}

export function useSpreadsheetSheets(
  input: ListSpreadsheetSheetsInput,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({ ...listSpreadsheetSheetsQueryOptions(input), enabled });
}
